var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEyeShowinline = function SvgEyeShowinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.955C4.556 12.955.274 7.04.102 6.797a.55.55 0 0 1 0-.638C.282 5.906 4.562 0 10 0c5.437 0 9.726 5.917 9.898 6.159a.55.55 0 0 1 0 .638c-.171.242-4.454 6.158-9.898 6.158ZM1.235 6.467c.952 1.203 4.57 5.389 8.765 5.389 4.194 0 7.813-4.18 8.765-5.39-.952-1.203-4.57-5.388-8.765-5.388-4.194 0-7.813 4.186-8.765 5.389ZM10 9.986a3.519 3.519 0 1 1 0-7.038 3.519 3.519 0 0 1 0 7.038Zm0-5.939a2.42 2.42 0 1 0 0 4.84 2.42 2.42 0 0 0 0-4.84Z",
    fill: "currentColor"
  })));
};
export default SvgEyeShowinline;